export default "__VITE_ASSET__DqcjIUgS__"